import * as IsActive from '../../components/is_active'

export const SERVER_RESOURCE = '/ippools'
export const FETCH_POOLS = 'FETCH_POOLS'
export const POOLS_FETCH_COMMUNITIES = 'POOLS_FETCH_COMMUNITIES'
export const PAGE_URL = '/admin/ip-pools'
export const POOL_CONFIG = 'POOL_CONFIG'

export const TOGGLE_DISPLAY_NAME = 'TOGGLE_DISPLAY_NAME'

export const DISPLAY_NAME: IsActive.Filter = {
  description: 'By Name',
  key: 'display',
  value: 'name',
}

export const DISPLAY_IDENTIFIER: IsActive.Filter = {
  description: 'By Identifier',
  key: 'display',
  value: 'community_identifier',
}

export const displayNameFilters = [
  DISPLAY_NAME,
  DISPLAY_IDENTIFIER,
]



// WEBPACK FOOTER //
// ./src/pages/ip-pools/constants.ts